/* istanbul ignore file - better tested visually */

import { classNames } from '@partful/shared/lib/classNames';
import { ComponentProps } from 'react';
import styles from './WizardPageLayout.module.scss';

export function WizardPageLayout({ className, children, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.layout, className)} {...rest}>
      {children}
    </div>
  );
}

export function WizardPageHeader({ className, children, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.header, className)} {...rest}>
      {children}
    </div>
  );
}

export function WizardPageContent({ className, children, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.content, className)} {...rest}>
      {children}
    </div>
  );
}

export function WizardPageFooter({ className, children, ...rest }: ComponentProps<'div'>) {
  return (
    <div className={classNames(styles.footer, className)} {...rest}>
      {children}
    </div>
  );
}
